// Tag for graphql format
const gql = String.raw;

const getOnCreateAssignment = () => gql`
	subscription onCreatePayPlanAssignment {
		onCreatePayPlanAssignment {
			users {
				upcomingPayPlanAssignment {
					acknowledgementDate
					assignmentDate
					planId {
						_id
						name
					}
				}
				_id
			}
		}
	}
`;

const getAssignmentsSubscriptions = () => [
	{
		context: "onCreatePayPlanAssignment",
		query: getOnCreateAssignment(),
	},
];

export { getAssignmentsSubscriptions, getOnCreateAssignment };
